// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import i18n from '../../../i18n';
import { AssignmentInd } from '@mui/icons-material';
import AssignDialog from '../../dialogs/AssignDialog';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class CryptoPaymentsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'cryptoPayments';
        this.Server = this.props.context.getState().server.cryptoPayments;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['merchantTerminal.name', 'coin.coin'];
        this.exportButton = true;

        const defaultHead = [
            {
                id: 'merchantTerminalId',
                label: 'merchantTerminal',
                alignRight: false,
                cell: 'Select',
                show: 'name+merchantTerminalUuid',
                object: 'merchantTerminal',
                from: 'publicMerchantTerminals',
                displayGrid: true
            },
            {
                id: 'assignedUser',
                label: 'assignedUser',
                alignRight: false,
                cell: 'Select',
                show: 'firstName+lastName',
                object: 'assignedUser',
                from: 'users',
                displayGrid: true,
                customSort: 'assignedUser.firstName',
            },
            {
                id: 'dateAssigned',
                label: 'dateAssigned',
                alignRight: false,
                cell: 'Date',
                disableEditor: true,
                displayGrid: true
            },
            {
                id: 'coinAmount',
                label: 'coinAmount',
                alignRight: false,
                cell: 'CryptoAmount',
                displayGrid: true
            },
            {
                id: 'coinId',
                label: 'coin',
                alignRight: false,
                cell: 'Select',
                from: 'cryptoCoins',
                object: 'coin',
                show: 'coin',
                displayGrid: true
            },
            {
                id: 'terminalAmount',
                label: 'terminalAmount',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'direction',
                label: 'direction',
                alignRight: false,
                cell: 'Items',
                items: ['in', 'out'],
                displayGrid: true
            },
            {
                id: 'transactionHash',
                label: 'transactionHash',
                alignRight: false,
                cell: 'Text',
                showCopyButton: true,
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head,
            openAssignDialog: false,
            cryptoPaymentId: ''
        };
    }

    handleOpenTransaction(event) {
        const { List, state } = this;
        const cryptoPaymentId = state.menuClickItemId;
        const item = List.find((it) => it.id === cryptoPaymentId);

        this.setState({ cryptoPaymentId });
        this.handleCloseMenu();
        try {
            const transactionHash = item.transactionHash;
            const link = item.coin ? item.coin.chainScannerLink : '';
            const url = `${link}${transactionHash}`;
            window.open(url, '_blank');
        } catch (e) {
            console.error(e);
        }
    }

    handleOpenAssign(event) {
        this.setState({
            openAssignDialog: true,
            cryptoPaymentId: this.state.menuClickItemId
        });
        this.handleCloseMenu();
    }
    handleCloseAssignDialog() {
        this.setState({ openAssignDialog: false, cryptoPaymentId: null });
    }
    handleSaveAssignDialog() {
        this.setState({ openAssignDialog: false, cryptoPaymentId: null });
        this.retrieveData();
    }

    renderCustomMenuItems() {
        const canAssign = this.allowedAction('assign-merchant-terminal');
        return [
            <MenuItem
                key="openTransaction"
                onClick={(event) => this.handleOpenTransaction(event)}
            >
                <LinkIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.openTransaction')}
            </MenuItem>,
            canAssign && (
                <MenuItem
                    key="assign"
                    onClick={(event) => this.handleOpenAssign(event)}
                >
                    <AssignmentInd sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.assignMerchantTerminal')}
                </MenuItem>
            )
        ];
    }

    renderCustom() {
        const itemId = this.state.cryptoPaymentId;
        const assignedId =
            this.List.find((it) => it.id === itemId)?.merchantTerminal?.id ||
            '';
        const assignableList =
            this.props.context.getState().controllersData
                .publicMerchantTerminals;
        if (!assignableList) {
            return null;
        }
        return (
            <div>
                {this.state.openAssignDialog && (
                    <AssignDialog
                        open={this.state.openAssignDialog}
                        itemIdKey="cryptoPaymentId"
                        assignedIdKey="merchantTerminalId"
                        title="assignMerchantTerminal"
                        controller="publicMerchantTerminals"
                        assignedKey="merchantTerminal"
                        itemId={itemId}
                        assignedId={assignedId}
                        assignableList={assignableList}
                        server={this.Server}
                        onClose={(event) => this.handleCloseAssignDialog(event)}
                        onSave={(event) => this.handleSaveAssignDialog(event)}
                    />
                )}
            </div>
        );
    }
}
